import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
export default [new Extend.Model(User) //
.attribute('levelXp').attribute('level').attribute('levelXpCurrent').attribute('levelXpNext').attribute('levelTitle')];